import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ModelGroup} from '../data/ModelGroup';
import * as aristoGlobals from '../globals';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class RestApiService {

  modelsAPI = aristoGlobals.ARISTOMETRIX_LOCAL_DATA_HOST + 'models.json';

  constructor(private http: HttpClient, private translate: TranslateService) { }

  getModels(): Observable<ModelGroup[]> {
    return this.http.get<ModelGroup[]>(this.modelsAPI);
  }

  public sendEmail(simulationSession: any): Observable<any> {
    const sendEmailAPI = aristoGlobals.ARISTOMETRIX_HOST + 'send/' + this.translate.getDefaultLang();
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

    const requestOptions = {headers: headers};
    return this.http.post(sendEmailAPI, simulationSession, requestOptions);
  }

}
